﻿import React, { useState } from "react";
import { DotLegalDialog, DotLegalPrettyScrollbar, DotLegalSearchField } from "@dotlegal/dotlegal-ui-components";
import { useDataMapping } from "./CustomerDialog.hooks";
import { useTranslation } from "../../localization/useTranslation";
import { List, ListItemText } from "@mui/material";
import DotLegalFullScreenSpinner from "../../common/components/dotLegalFullScreenSpinner/DotLegalFullScreenSpinner";
import { useDotLegalCompanySelector } from "../../common/components/dotLegalCompanySelector/GroupCompanySelectorContext";

import ListItemButton from "@mui/material/ListItemButton";

export interface ICustomerDialogProps {
    children: JSX.Element;
}

function CustomerDialog(props: ICustomerDialogProps) {
    const { translateString } = useTranslation();
    const { setSelectedGroupCompany } = useDotLegalCompanySelector();

    const { isLoading, customers, onCustomerChosen, onDialogClose, showDialog } = useDataMapping();
    const [searchInput, setSearchInput] = useState("");

    const filteredCustomers = customers.filter((c) => c.name.toLowerCase().includes(searchInput.toLowerCase()));

    let content = <DotLegalFullScreenSpinner />;
    if (!isLoading) {
        if (showDialog) {
            content = (
                <DotLegalDialog
                    disableOnClose
                    header={translateString("chooseCustomerToLoginWith")}
                    onDialogClose={onDialogClose}
                    buttonOkText={translateString("close")}
                    onOkClick={onDialogClose}
                    open
                    hideOkButton
                    isLoading={isLoading}
                    size={"md"}
                >
                    <DotLegalSearchField labelSearch={translateString("search")} useFullWidth autoFocus value={searchInput} onChange={setSearchInput} />
                    <DotLegalPrettyScrollbar sx={{ height: "60vh" }}>
                        <List component="nav" aria-label="customers">
                            {filteredCustomers.map((c) => (
                                <ListItemButton
                                    key={c.id}
                                    onClick={() => {
                                        setSelectedGroupCompany(undefined);
                                        onCustomerChosen(c.id);
                                    }}
                                >
                                    <ListItemText primary={c.name} />
                                </ListItemButton>
                            ))}
                        </List>
                    </DotLegalPrettyScrollbar>
                </DotLegalDialog>
            );
        } else {
            content = props.children;
        }
    }

    return <React.Fragment>{content}</React.Fragment>;
}

export default CustomerDialog;
